export enum EventTypesEnum {
  CLOSED = 'CLOSED',
  TOURNAMENT = 'TOURNAMENT',
  GREENS_AERIFICATION = 'GREENS_AERIFICATION',
  OVERSEEDING_GREENS = 'OVERSEEDING_GREENS',
  FULL_DAY_TOURNAMENT = 'FULL_DAY_TOURNAMENT',
  CART_PATH = 'CART_PATH',
  HOLIDAY = 'HOLIDAY',
  BLOCK_TRADE_ROUNDS = 'BLOCK_TRADE_ROUNDS',
  OVERRIDE_NATIONAL_HOLIDAY = 'OVERRIDE_NATIONAL_HOLIDAY',
  NATIONAL_HOLIDAY = 'NATIONAL_HOLIDAY',
  CUSTOM = 'CUSTOM',
}

export const hiddenEventTypes = [
  EventTypesEnum.HOLIDAY,
  EventTypesEnum.NATIONAL_HOLIDAY,
  EventTypesEnum.BLOCK_TRADE_ROUNDS,
  EventTypesEnum.OVERRIDE_NATIONAL_HOLIDAY,
  EventTypesEnum.CUSTOM,
];

export const getCalendarEventName = (event: EventTypesEnum): string => {
  switch (event) {
    case EventTypesEnum.CUSTOM:
      return 'Custom Event';
    case EventTypesEnum.CLOSED:
      return 'Course Closed';
    case EventTypesEnum.BLOCK_TRADE_ROUNDS:
      return 'Block Trade Rounds';
    case EventTypesEnum.CART_PATH:
      return 'Cart Path Only';
    case EventTypesEnum.HOLIDAY:
      return 'Holiday';
    case EventTypesEnum.TOURNAMENT:
      return 'Tournament';
    case EventTypesEnum.OVERRIDE_NATIONAL_HOLIDAY:
      return 'Override National Holiday';
    case EventTypesEnum.FULL_DAY_TOURNAMENT:
      return 'Full Day Tournament';
    case EventTypesEnum.OVERSEEDING_GREENS:
      return 'Overseeding Greens';
    case EventTypesEnum.GREENS_AERIFICATION:
      return 'Greens Aerification';
    case EventTypesEnum.NATIONAL_HOLIDAY:
      return 'National Holiday';
  }
};

